// src/mixins/permissions.js
// Atajos de permisos para usar en cualquier página.
// Usa automáticamente el recurso de la ruta actual ($route.name),
// que es el mismo `uri` con el que se guardan los permisos.
//
// Uso en una página:
//   import permissions from '@/mixins/permissions';
//   export default { mixins: [permissions], ... }
//
//   <v-btn v-if="canCreate" ...>Nuevo</v-btn>
//   <v-btn v-if="canEdit" ...>Editar</v-btn>
//   <v-btn v-if="canDelete" ...>Eliminar</v-btn>
//   <!-- para un botón de acción parametrizado o un recurso distinto: -->
//   <v-btn v-if="canDo('generate-xml-sales-purchases')" ... />
//   <v-btn v-if="canDo('update', 'journal')" ... />

export default {
	computed: {
		permissionUri() {
			return (this.$route && this.$route.name) || '';
		},
		canCreate() {
			return this.$can(this.permissionUri, 'create');
		},
		canRead() {
			return this.$can(this.permissionUri, 'read');
		},
		canEdit() {
			return this.$can(this.permissionUri, 'update');
		},
		canDelete() {
			return this.$can(this.permissionUri, 'delete');
		},
	},
	methods: {
		// canDo('update')            -> sobre el recurso de la ruta actual
		// canDo('update', 'journal') -> sobre un recurso específico
		// canDo('generate-xml...')   -> code de un botón parametrizado
		canDo(action, uri) {
			return this.$can(uri || this.permissionUri, action);
		},
	},
};



// WEBPACK FOOTER //
// ./src/mixins/permissions.js